import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTheme } from '@mui/material/styles';

import * as selectorsAuth from '../../../../../../store/auth/reducer';
import * as selectorsModuleConfiguration from '../../../../../../store/moduleConfiguration/reducer';
import { isAdmin } from '../../../../../../constants/role';
import { fetchMyOptionCodes } from '../../../../../../helpers/optionApi';

import { buildMainV2NavItems } from '../../../sidebarMenu/buildMainV2NavItems';
import { filterNavItems } from '../../../sidebarMenu/filterNavItems';
import { SideNav } from './side-nav';

const SidebarV2 = ({
  userRole,
  authData,
  moduleConfigurations,
  isDesktop = true,
  openMenu = false,
  onMenuClose,
}) => {
  const theme = useTheme();
  const [optionCodes, setOptionCodes] = useState([]);
  const admin = isAdmin(userRole);

  useEffect(() => {
    if (!authData?.id || admin) {
      setOptionCodes([]);
      return undefined;
    }
    let cancel = false;
    fetchMyOptionCodes()
      .then((codes) => {
        if (!cancel) setOptionCodes(codes);
      })
      .catch(() => {
        if (!cancel) setOptionCodes([]);
      });
    return () => {
      cancel = true;
    };
  }, [authData?.id, admin]);

  const rawItems = buildMainV2NavItems({ userRole, authData, moduleConfigurations, optionCodes });
  const items = filterNavItems(rawItems);
  const sections = [{ subheader: '', items }];

  return (
    <SideNav
      color={theme.palette.mode === 'dark' ? 'evident' : 'blend-in'}
      isDesktop={isDesktop}
      openMenu={openMenu}
      onMenuClose={onMenuClose}
      sections={sections}
    />
  );
};

SidebarV2.propTypes = {
  authData: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool,
  openMenu: PropTypes.bool,
  moduleConfigurations: PropTypes.array,
  onMenuClose: PropTypes.func,
  userRole: PropTypes.string,
};

const mapStateToProps = (state) => ({
  userRole: selectorsAuth.getRole(state),
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
});

export default connect(mapStateToProps)(SidebarV2);
